var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M-332.7,267.5h-54c-1.8,0-3.4,1.5-3.4,3.4v54c0,1.9,1.5,3.4,3.4,3.4h29.1v-23.5h-7.9v-9.2h7.9v-6.8\r\n\t\tc0-7.8,4.8-12.1,11.8-12.1c3.4,0,6.2,0.3,7.1,0.4v8.2h-4.9c-3.8,0-4.5,1.8-4.5,4.5v5.9h9.1l-1.2,9.2h-7.9v23.5h15.5\r\n\t\tc1.9,0,3.4-1.5,3.4-3.4v-54C-329.4,269-330.9,267.5-332.7,267.5z"})));
}

Facebook.defaultProps = {"version":"1.1","id":"facebook","x":"0px","y":"0px","viewBox":"-390 267.6 60.7 60.7","style":{"enableBackground":"new -390 267.6 60.7 60.7"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
